import { api1C } from './api';

export const get1cCatalogs = (params) => {
    return api1C.get('catalogs', {
        params,
    });
}
    
